// import { uploadAvatarFile } from "@/shared/lib/upload-avatar"; // field image comment ไว้

import { Card, CardContent, CardHeader, CardTitle, toast } from "@devhop/ui";
import { useState } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { profileApi } from "../api/client";
import { useAuthState } from "../model/useAuthState";
import { ProfileForm } from "../ui/ProfileForm";

/** หน้าໂປຣໄຟລ໌ — ใช้ layout เดียวกับหน้าอื่น (ไม่มี Header แยก, เนื้อหาอยู่ใน SidebarInset) */
export function ProfilePage() {
  const { user, refetch } = useAuthState();
  const [submitting, setSubmitting] = useState(false);

  return (
    <>
      <Header>
        <Breadcrumb items={[{ label: "ໂປຣໄຟລ໌" }]} />
      </Header>
      <Main>
        <h1 className="mb-2 font-semibold text-xl">ໂປຣໄຟລ໌ຂອງຂ້ອຍ</h1>
        <p className="mb-6 text-muted-foreground text-sm">ຈັດການການຕັ້ງຄ່າບັນຊີ.</p>

        <Card>
          <CardHeader>
            <CardTitle>ໂປຣໄຟລ໌</CardTitle>
          </CardHeader>
          <CardContent>
            <ProfileForm
              initialValues={{
                name: user?.name ?? "",
                // image: user?.image ?? undefined,
              }}
              submitting={submitting}
              onSubmit={async (vals) => {
                setSubmitting(true);
                try {
                  // field image — comment ไว้
                  // let imageKey: string | null | undefined = vals.image ?? undefined;
                  // if (vals.imageFile instanceof File) {
                  //   imageKey = await uploadAvatarFile(vals.imageFile);
                  // }
                  const fd = new FormData();
                  fd.append("name", vals.name);
                  if (vals.password) fd.append("password", vals.password);
                  // if (vals.image === null && !vals.imageFile) {
                  //   fd.append("imageDelete", "1");
                  // } else if (typeof imageKey === "string" && imageKey) {
                  //   fd.append("image", imageKey);
                  // }
                  await profileApi.update(fd);
                  toast.success("ອັບເດດໂປຣໄຟລ໌ສໍາເລັດ");
                  refetch();
                } finally {
                  setSubmitting(false);
                }
              }}
            />
          </CardContent>
        </Card>
      </Main>
    </>
  );
}
